// This function takes a date object and returns a string in the format "DD-Month-YYYY"
// where DD is the day of the month, Month is the full name of the month, and YYYY is the year.
export default function getDayForm(date=new Date()) {
      const months = [
        'January','February','March','April','May','June',
        'July','August','September','October','November','December'];
      return  String(date.getDate()).padStart(2,"0") + '-' + months[date.getMonth()] + '-' + date.getFullYear();
  }